import Ajax from '../../../../util/ajax';
export function zigbeeGetUserStatus(nid, eid, payload) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch, true);
        const url = '/zigbee/' + nid + '/ep/' + eid + '/cluster/0x0101/command/get-user-status';
        const value = {
            'userID': payload.userID
        };
        ajax.post(url, value);
    };
}
